import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .asl-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #f0f2f8;
    min-height: 100vh;
    padding: 2rem 1rem;
    color: #1a1d2e;
  }

  .asl-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .asl-header-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #2563eb, #7c3aed);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .asl-header-icon svg {
    width: 24px;
    height: 24px;
    fill: white;
  }

  .asl-header-text h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    color: #1a1d2e;
    letter-spacing: -0.02em;
  }

  .asl-header-text p {
    font-size: 0.85rem;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
  }

  .asl-error-banner {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-left: 4px solid #ef4444;
    border-radius: 10px;
    padding: 1rem 1.25rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    color: #991b1b;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .asl-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5rem 2rem;
    gap: 1rem;
  }

  .asl-spinner {
    width: 44px;
    height: 44px;
    border: 3px solid #e5e7eb;
    border-top-color: #2563eb;
    border-radius: 50%;
    animation: asl-spin 0.8s linear infinite;
  }

  @keyframes asl-spin {
    to { transform: rotate(360deg); }
  }

  .asl-loading p {
    color: #6b7280;
    font-size: 0.9rem;
    margin: 0;
  }

  /* Accordion */
  .asl-accordion {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .asl-card {
    background: white;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04);
    transition: box-shadow 0.2s;
  }

  .asl-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08), 0 8px 32px rgba(0,0,0,0.06);
  }

  .asl-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.1rem 1.5rem;
    cursor: pointer;
    user-select: none;
    gap: 1rem;
    transition: background 0.15s;
  }

  .asl-card-header:hover {
    background: #f9fafb;
  }

  .asl-card-header-left {
    display: flex;
    align-items: center;
    gap: 0.875rem;
  }

  .asl-badge-active {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: #dcfce7;
    color: #166534;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25rem 0.65rem;
    border-radius: 999px;
    border: 1px solid #bbf7d0;
    letter-spacing: 0.01em;
  }

  .asl-badge-passive {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: #fef3c7;
    color: #92400e;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25rem 0.65rem;
    border-radius: 999px;
    border: 1px solid #fde68a;
    letter-spacing: 0.01em;
  }

  .asl-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }

  .asl-card-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #1a1d2e;
    margin: 0;
    letter-spacing: -0.01em;
  }

  .asl-chevron {
    width: 20px;
    height: 20px;
    color: #9ca3af;
    flex-shrink: 0;
    transition: transform 0.25s ease;
  }

  .asl-chevron.open {
    transform: rotate(180deg);
  }

  .asl-card-body {
    border-top: 1px solid #f3f4f6;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease;
  }

  .asl-card-body.open {
    max-height: 2000px;
  }

  .asl-card-body-inner {
    padding: 1.5rem;
  }

  /* Form Card */
  .asl-form-card {
    background: white;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04);
    overflow: hidden;
  }

  .asl-form-card-header {
    padding: 1.25rem 1.75rem;
    background: linear-gradient(135deg, #1e3a8a 0%, #3730a3 100%);
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .asl-form-card-header svg {
    width: 20px;
    height: 20px;
    fill: rgba(255,255,255,0.85);
    flex-shrink: 0;
  }

  .asl-form-card-header h2 {
    font-size: 1rem;
    font-weight: 600;
    color: white;
    margin: 0;
    letter-spacing: -0.01em;
  }

  .asl-form-body {
    padding: 1.75rem;
  }

  .asl-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 640px) {
    .asl-form-grid {
      grid-template-columns: 1fr;
    }
    .asl-root {
      padding: 1rem 0.75rem;
    }
    .asl-header-text h1 {
      font-size: 1.2rem;
    }
  }

  .asl-field label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.45rem;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  .asl-field textarea {
    width: 100%;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 0.7rem 0.9rem;
    font-size: 0.9rem;
    font-family: 'JetBrains Mono', monospace;
    color: #1a1d2e;
    background: #f9fafb;
    resize: none;
    height: 52px;
    transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    box-sizing: border-box;
  }

  .asl-field textarea:focus {
    outline: none;
    border-color: #2563eb;
    background: white;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
  }

  .asl-submit-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    background: linear-gradient(135deg, #2563eb, #4f46e5);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 0.8rem 2rem;
    font-size: 0.9rem;
    font-weight: 600;
    font-family: 'Plus Jakarta Sans', sans-serif;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
    box-shadow: 0 4px 14px rgba(37,99,235,0.35);
    letter-spacing: -0.01em;
  }

  .asl-submit-btn:hover {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(37,99,235,0.4);
  }

  .asl-submit-btn:active {
    transform: translateY(0);
  }

  .asl-submit-btn svg {
    width: 16px;
    height: 16px;
    fill: white;
  }

  .asl-form-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 0.25rem;
  }
`;

function AdminSchoolList() {
    const [data, setData] = useState([]);
    const [passivedata, setpassivedata] = useState([]);
    const [activeOpen, setActiveOpen] = useState(true);
    const [passiveOpen, setPassiveOpen] = useState(false);

    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    const columns = React.useMemo(
        () => [
            {
                Header: t("schoolId"),
                Footer: t("schoolId"),
                accessor: 'id',
            },
            {
                Header: t("schoolName"),
                Footer: t("schoolName"),
                accessor: 'schoolName',
            },
            {
                Header: t("studentLimit"),
                Footer: t("studentLimit"),
                accessor: 'studentLimit',
            },
            {
                Header: t("createdAt"),
                Footer: t("createdAt"),
                accessor: 'createdAt',
            },
            {
                Header: t("finishDate"),
                Footer: t("finishDate"),
                accessor: 'expiryDate',
            },
            {
                Header: t("idDeleted"),
                Footer: t("idDeleted"),
                accessor: 'idDeleted',
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: 'isActive',
            },
            {
                Header: t("edit"),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-warning mr-2 btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'action',
                Footer: 'Düzenle',
            },
        ],
        [],
    );

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = `${API_BASE_URL}/admin/School/AssignManager`; // API_BASE_URL kullanımı
            await axios({
                method: 'Get',
                url: url,
                params: {
                    email: document.getElementById("email").value,
                    schoolId: document.getElementById("schoolId").value,
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                        document.getElementById("email").value = "";
                        document.getElementById("schoolId").value = "";
                    } else {
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`
                        });
                        setMsg(res.data['message']);
                    }
                } else {
                    Swal.fire({
                        title: "hata!",
                        icon: "error",
                        confirmButtonText: `Tamam`
                    });
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            Swal.fire({
                title: err.message,
                icon: "error",
                confirmButtonText: `Tamam`
            });
            setMsg(err);
        }
    };

    const handleEdit = (row) => {
        window.location.href = "editschool/" + row['id'];
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                };
                let url = `${API_BASE_URL}/admin/School/SchoolList`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            console.log(res.data['data'][0]['isActive']);
                            for (let i = 0; i < res.data['data'].length; i++) {
                                let b = "";
                                if (res.data['data'][i]['isDeleted']) {
                                    b = t('deleted');
                                } else {
                                    b = t('active');
                                }
                                let a = "";
                                if (res.data['data'][i]['isActive']) {
                                    a = t('active');
                                    data.push({
                                        "id": res.data['data'][i]['id'],
                                        "schoolName": res.data['data'][i]['schoolName'],
                                        "studentLimit": res.data['data'][i]['studentLimit'],
                                        "createdAt": formatDate(res.data['data'][i]['createdAt']),
                                        "expiryDate": formatDate(res.data['data'][i]['expiryDate']),
                                        "isActive": a,
                                        "idDeleted": b
                                    });
                                } else if (!res.data['data'][i]['isActive']) {
                                    a = t('passive');
                                    passivedata.push({
                                        "id": res.data['data'][i]['id'],
                                        "schoolName": res.data['data'][i]['schoolName'],
                                        "studentLimit": res.data['data'][i]['studentLimit'],
                                        "createdAt": formatDate(res.data['data'][i]['createdAt']),
                                        "expiryDate": formatDate(res.data['data'][i]['expiryDate']),
                                        "isActive": a,
                                        "idDeleted": b
                                    });
                                }
                            }
                        } else {
                            setMsg(res.data['message']);
                        }
                    } else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            } catch (err) {
                setMsg(err);
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    return (
        <>
            <style>{styles}</style>
            <div className="asl-root">

                {/* Page Header */}
                <div className="asl-header">
                    <div className="asl-header-icon">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z" />
                        </svg>
                    </div>
                    <div className="asl-header-text">
                        <h1>{t("schoolList")}</h1>
                        <p>Okul yönetimi ve yönetici atama paneli</p>
                    </div>
                </div>

                {/* Error Message */}
                {msg && msg.length > 0 && (
                    <div className="asl-error-banner">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {msg}
                    </div>
                )}

                {/* Loading State */}
                {loading && (
                    <div className="asl-loading">
                        <div className="asl-spinner" />
                        <p>Veriler yükleniyor...</p>
                    </div>
                )}

                {/* Main Content */}
                {!loading && (
                    <div className="asl-accordion">

                        {/* Active Schools */}
                        <div className="asl-card">
                            <div
                                className="asl-card-header"
                                onClick={() => setActiveOpen(!activeOpen)}
                            >
                                <div className="asl-card-header-left">
                                    <span className="asl-badge-active">
                                        <span className="asl-badge-dot" />
                                        Aktif
                                    </span>
                                    <p className="asl-card-title">{t("schoolList")}</p>
                                </div>
                                <svg className={`asl-chevron ${activeOpen ? 'open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>
                            <div className={`asl-card-body ${activeOpen ? 'open' : ''}`}>
                                <div className="asl-card-body-inner">
                                    <Datatable data={data} columns={columns} tableBaslik={t("schoolList")} />
                                </div>
                            </div>
                        </div>

                        {/* Passive Schools */}
                        <div className="asl-card">
                            <div
                                className="asl-card-header"
                                onClick={() => setPassiveOpen(!passiveOpen)}
                            >
                                <div className="asl-card-header-left">
                                    <span className="asl-badge-passive">
                                        <span className="asl-badge-dot" />
                                        Pasif
                                    </span>
                                    <p className="asl-card-title">{t("passiveschoolList")}</p>
                                </div>
                                <svg className={`asl-chevron ${passiveOpen ? 'open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>
                            <div className={`asl-card-body ${passiveOpen ? 'open' : ''}`}>
                                <div className="asl-card-body-inner">
                                    <Datatable data={passivedata} columns={columns} tableBaslik={t("passiveschoolList")} />
                                </div>
                            </div>
                        </div>

                    </div>
                )}

                {/* Assign Manager Form */}
                <div className="asl-form-card">
                    <div className="asl-form-card-header">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                        </svg>
                        <h2>Yönetici Ata</h2>
                    </div>
                    <div className="asl-form-body">
                        <form onSubmit={handleSubmit}>
                            <div className="asl-form-grid">
                                <div className="asl-field">
                                    <label htmlFor="email">{t("userEmail")}</label>
                                    <textarea id="email" required />
                                </div>
                                <div className="asl-field">
                                    <label htmlFor="schoolId">{t("schoolId")}</label>
                                    <textarea id="schoolId" required />
                                </div>
                            </div>
                            <div className="asl-form-footer">
                                <button type="submit" className="asl-submit-btn">
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                    </svg>
                                    {t("create")}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
}

export default AdminSchoolList;
